import { render, staticRenderFns } from "./ProprietarioVeiculo.vue?vue&type=template&id=28b22297"
import script from "./ProprietarioVeiculo.vue?vue&type=script&lang=js"
export * from "./ProprietarioVeiculo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports